export type WorkspaceSearchChannel =
    | "AIRBRIDGE"
    | "APPLE_SEARCH"
    | "APPSFLYER"
    | "CAFE24"
    | "CRITEO"
    | "EXTERNAL"
    | "FACEBOOK"
    | "GOOGLE_ADS"
    | "GOOGLE_ANALYTICS"
    | "KAKAO"
    | "KAKAO_KEYWORD"
    | "MOLOCO"
    | "NAVER_GFA"
    | "NAVER_GFA_SCRAPY"
    | "NAVER_NOSP"
    | "NAVER_SA"
    | "REMERGE"
    | "TIKTOK"
    | "TWITTER";

export const WORKSPACE_SEARCH_CHANNELS: WorkspaceSearchChannel[] = [
    "AIRBRIDGE",
    "APPLE_SEARCH",
    "APPSFLYER",
    "CAFE24",
    "CRITEO",
    "EXTERNAL",
    "FACEBOOK",
    "GOOGLE_ADS",
    "GOOGLE_ANALYTICS",
    "KAKAO",
    "KAKAO_KEYWORD",
    "MOLOCO",
    "NAVER_GFA",
    "NAVER_GFA_SCRAPY",
    "NAVER_NOSP",
    "NAVER_SA",
    "REMERGE",
    "TIKTOK",
    "TWITTER",
];

export interface WorkspaceSearchParams {
    orgId: string;
    channel: WorkspaceSearchChannel;
    dwAccountId: string;
}

export interface WorkspaceSearchRow {
    orgName: string;
    workspaceId: string;
    workspaceName: string;
    orgId: string;
    accountId: string;
    accountName: string;
}

export interface SearchWorkspaceResponse {
    rows: Array<{
        org_name?: string;
        workspace_id?: string;
        workspace_name?: string;
        org_id?: string;
        account_id?: string;
        account_name?: string;
    }>;
}